// extracted by mini-css-extract-plugin
module.exports = {"customButton":"style_customButton__14Ts-","text":"style_text__2Kblz","loader":"style_loader__W5kAT","spin":"style_spin__2Sdny"};